import type { CatalogItem } from '~/models/common'

export const companySizes: CatalogItem[] = [
  {
    label: '1-10',
    value: 1,
  },
  {
    label: '11-30',
    value: 2,
  },
  {
    label: '31-70',
    value: 3,
  },
  {
    label: '71-100',
    value: 4,
  },
  {
    label: '101-150',
    value: 5,
  },
  {
    label: '151-300',
    value: 6,
  },
  {
    label: 'over 300',
    value: 7,
  },
]
